import React from "react";
import { Link } from "react-router-dom";
import { Lock, ShieldCheck, Coins, GitBranch } from "lucide-react";

export default function LockDashboard() {
  return (
    <section className="min-h-[82vh] grid place-items-center px-5 grid-bg" data-testid="lock-dashboard">
      <div className="relative max-w-md w-full text-center">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-80 h-80 brand-glow rounded-full pointer-events-none" />
        <div className="relative rud-card rounded-3xl p-10">
          <span className="w-14 h-14 rounded-full bg-brand text-black grid place-items-center mx-auto"><Lock size={24} /></span>
          <div className="text-xs uppercase tracking-[0.2em] text-brand mt-6">God Mode locked</div>
          <h1 className="font-serif text-3xl sm:text-4xl tracking-tight mt-3 leading-tight">Sign in to unlock</h1>
          <p className="text-sec text-sm mt-3 leading-relaxed">Signing in loads your Prosperity dashboard, credits and earnings. Use your email or Google — it's free to start.</p>

          <div className="flex items-center justify-center gap-4 text-[11px] text-sec my-5">
            <span className="flex items-center gap-1"><ShieldCheck size={13} className="text-brand" /> Data-sovereign</span>
            <span className="flex items-center gap-1"><Coins size={13} className="text-brand" /> Your credits</span>
            <span className="flex items-center gap-1"><GitBranch size={13} className="text-brand" /> Referral earnings</span>
          </div>

          <Link to="/auth" data-testid="lock-signin" className="btn-primary rounded-full w-full h-11 flex items-center justify-center gap-2 text-sm">
            Sign in to unlock God Mode
          </Link>
        </div>
      </div>
    </section>
  );
}
